module.exports = __webpack_public_path__ + "img/dp12.72542591.jpeg";